import React, { useState, useEffect } from 'react';
import { PlusIcon, SparklesIcon } from '@heroicons/react/24/solid';
import './SwitchPlanModal.css';
import PlanWizard from './PlanWizard';

const SwitchPlanModal = ({ close, backendService, onPlanSelected, currentPlanId, modalService }) => {
  const [plans, setPlans] = useState([]);
  const [showWizard, setShowWizard] = useState(false);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const data = await backendService.fetchPlans();
        setPlans(data);
      } catch (error) {
        console.error('[SwitchPlanModal] Failed to fetch plans:', error);
      }
    };
    fetchPlans();
  }, [backendService]);

  const handleCreatePlanQuick = async () => {
    try {
      const data = await backendService.createPlan("New Workout Plan", "");
      onPlanSelected(data._id);
      close();
    } catch (error) {
      console.error('[SwitchPlanModal] Failed to create plan:', error);
    }
  };

  const handleOpenWizard = () => {
    setShowWizard(true);
  };

  const handleWizardComplete = (newPlanId) => {
    onPlanSelected(newPlanId);
    close();
  };

  const handleSelectPlan = (planId) => {
    onPlanSelected(planId);
    close();
  };

  if (showWizard) {
    return (
      <PlanWizard
        close={close}
        modalService={modalService}
        backendService={backendService}
        onPlanCreated={handleWizardComplete}
        isOnboarding={false}
      />
    );
  }

  return (
    <div className="switch-plan-modal">
      <h2 className="switch-plan-header">Switch Workout Plan</h2>
      <div className="switch-plan-list">
        {plans.map(plan => (
          <button
            key={plan._id}
            className={`switch-plan-item ${plan._id === currentPlanId ? 'active' : ''}`}
            onClick={() => handleSelectPlan(plan._id)}
          >
            <span className="switch-plan-name">{plan.title || 'Untitled Plan'}</span>
            {plan._id === currentPlanId && <span className="switch-plan-current">(Current)</span>}
          </button>
        ))}
      </div>
      <div className="switch-plan-actions">
        <button className="btn-create-plan-wizard" onClick={handleOpenWizard}>
          <SparklesIcon className="btn-icon" /> Create with AI Wizard
        </button>
        <button className="btn-create-plan-quick" onClick={handleCreatePlanQuick}>
          <PlusIcon className="btn-icon" /> Quick Empty Plan
        </button>
        <button className="btn-cancel-switch" onClick={close}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default SwitchPlanModal;
